import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types";

const endpoint = {
  myCommissions: "/commissions/my-commissions",
};

export const fetchMyCommissions = createAsyncThunk(
  "myCommissions/fetchMyCommissions",
  async (params: Params, thunkAPI) => {
    try {
      // If caller provides an explicit `establishment_slug`, call the
      // root API and include the slug in the path to avoid duplicate/missing
      // segments that can cause 404s in some deployments.
      const { establishment_slug, ...query } = (params as any) || {};

      if (establishment_slug) {
        const url = `/establishment/${establishment_slug}${endpoint.myCommissions}`;
        const response = await axiosInstance.get(url, {
          params: { ...query, include_products: query.include_products ?? 1 },
          baseURL: process.env.NEXT_PUBLIC_API_URL,
        });
        return response.data;
      }

      const response = await axiosInstance.get(endpoint.myCommissions, {
        params: {
          ...params,
          include_products: (params as any)?.include_products ?? 1,
        },
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const backend = error.response?.data as {
          message?: string;
          errors?: any;
        };

        return thunkAPI.rejectWithValue({
          message: backend?.message || "Erro desconhecido ao buscar comissões.",
          errors: backend?.errors || {},
        });
      }

      return thunkAPI.rejectWithValue({
        message: "Erro inesperado.",
        errors: {},
      });
    }
  },
);
